// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"yo-z","imageAndVideoCount":"zo-z","imageAndVideoContainer":"Ao-z","viewAllReviews":"Bo-z"};